import { ClsItem, cCommentStatus, cStatus } from './clsType';

import { UploadFile } from 'features/NktFileUploader/types';
import { FileDescriptor } from './fileTypes';
import { UploadFiles } from './uploadType';

export type PostFile = {
  id: string;
  path: string;
  filename: string;
  contentType: string;
  fileSize: number;
  fileType: number;
};

export type PostUploadType = {
  title?: string;
  text?: string;
  id?: string;
  cType?: string;
  files?: FileDescriptor[];
  feeds?: PostFeedType[];
  up?: PostType['up'];
  upPost?: PostType['upPost'];
};

export type PostMetadata = {
  comment_count: number;
  view_count: number;
  repost_count: number;
  reaction_count?: number;
  user_reacted?: boolean;
};

export type AuthorDescription = {
  fullName: string;
  imageUrl: string;
  rEntity: string;
};

type CommentMetaType = {
  comment_count?: number;
  reaction_count: number;
  reactions: KeyValue<string>;
};

export type CommentType = {
  authorInfo: AuthorDescription;
  id: string;
  sd: string;
  ed: string;
  up: string | null;
  meta?: CommentMetaType;
  myReaction: string | null;
  publicationDate: string;
  rAuthor: string;
  rPost: string;
  cStatus: cStatus;
  cStatusItem: ClsItem;
  text: string;
  files: [];
  rAuthorId: string;
  uref: string;
};

export type PartialCommentType = { [P in 'rAuthor' | 'rPost' | 'text' | 'up']: CommentType[P] } & {
  [P in 'cStatus']?: CommentType[P];
};

export type PostFeedType = {
  feedId: string;
  feedItemId: string;
  feedTitle: string;
};

export type PostType = {
  authorInfo: AuthorDescription;
  feedOwnerInfo: AuthorDescription;
  id: string;
  sd: string;
  ed: string;
  up: string | null;
  upPost: PostType | null;
  publicationDate: string;
  rAuthor: string;
  title: string;
  subtitle: string | null;
  shortText: string | null;
  cCommentStatus: cCommentStatus;
  commentNtfStatus: boolean;
  cCommentStatusItem: ClsItem;
  dsc: string | null;
  jsonDsc: string | null;
  cCategories: string[]; //uref
  categoriesMap?: KeyValue<{ term: string; code: string }>;
  cStatus: cStatus;
  cStatusItem: ClsItem;
  rUserGroup: null;
  rRole: null;
  files: UploadFile[] | UploadFiles[] | FileDescriptor[];
  text: string | null;
  feeds: PostFeedType[];
  rAuthorId: string;
  uref: string;
  meta: PostMetadata;
  myReaction?: string;
  link: string;
};

export enum CommentsViewTypeEnum {
  linear = 'linear',
  tree = 'tree',
  secondLevel = 'second_level',
}

export enum CommentsMode {
  popular = 'popular',
  inOrder = 'in_order',
}

export type PostGetCommentPayload = {
  id: null; // ID уведомления в БД
  ts: string; // time stamp
  cType: string; // 169:9 Тип уведомления
  uref: string;
  rObj: string; //'304:57384c5f-d916-4d38-b7c3-0ca6fa4a689a' -- комментарий
  rParObj: string; // '302:283ac405-2b14-4148-b3ab-e8a59943c7db' // пост
  rSrc: string; //'202:d10a54e7-c261-4069-83d2-cc81d7d25a57' // автор  комментария
  rDst: string | null; // uref получателя уведомления. Для уведомлений 1 к 1 будет содержать uref пользователя-адресата. Для рассылок подписчикам будет пустым
  html: string; // Вложенный html
  cid: string; // Уникальный контекстный ID уведомления
};

export type PostGetCommentType = {
  cType: string;
  rParObj: string;
  rSrc: string;
  rObj: string;
  html: string;
};
